import React from 'react';
import LabelFormMyPage from 'page/Application/MyPage/component/FormMyPage/LabelFormMyPage';
import { FormValidateTextAndNumber } from 'components/Form2';
import {
  GridFormAccount,
  GridFormAccount1to2,
  GridFormAccount2to3,
} from 'page/Application/MyPagePartnerAdmin/styled';
import useMultiLanguageRegisterAccount from 'page/Application/ManageAccountSoliton/RegisterAccountSoliton/hook/useMultiLanguageRegisterAccount';

const Position = ({ editMode }) => {
  const { REGISTER_ACCOUNT_PLACEHOLDER_POSITION } =
    useMultiLanguageRegisterAccount();

  return (
    <GridFormAccount>
      <GridFormAccount1to2>
        <LabelFormMyPage labelText={'役職'} />
      </GridFormAccount1to2>

      <GridFormAccount2to3>
        <FormValidateTextAndNumber
          name="position"
          required={false}
          placeholder={editMode && REGISTER_ACCOUNT_PLACEHOLDER_POSITION}
        />
      </GridFormAccount2to3>
    </GridFormAccount>
  );
};

export default Position;
